import { formatDate } from '@angular/common';
import { HttpFilter } from 'sol-request-angular/dist/comunicacao';
import { Equal } from 'sol-request-angular/dist/comunicacao/filter/Equal';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';

export class ConcessaoVeiculoSearch {
    
    cdConcessao: number;
    cdPessoa: number;
    cdConcessaoVeiculo: number;
    cdVeiculo: number;
    nmPessoa: string;
    nmModelo: string;
    nmUsuario: string;
    nrPlaca: string;
    nrPrefixo: string;
    nrIdentificador: string;
    nrAnoFabricacao: string;
    tpConcessao: number;
    stConcessaoVeiculo: number;
    stConcessao: number;
    dtInicioOperacao: string;
    dtInicialVinculacao: string;
    dtFinalVinculacao: string;
    dtInicialDesvinculacao: string;
    dtFinalDesvinculacao: string;
    cdConcessionario: number;
    limit: number;
    page: number;
    orderBy: string;

    constructor(data?: {
        cdConcessao?: number;
        cdPessoa?: number;
        cdConcessaoVeiculo?: number;
        cdVeiculo?: number;
        nmPessoa?: string;
        nmModelo?: string;
        nmUsuario?: string;
        nrPlaca?: string;
        nrPrefixo?: string;
        nrIdentificador?: string;
        nrAnoFabricacao?: string;
        tpConcessao?: number;
        stConcessaoVeiculo?: number;
        stConcessao?: number;
        dtInicioOperacao?: string;
        dtInicialVinculacao?: string;
        dtFinalVinculacao?: string;
        dtInicialDesvinculacao?: string;
        dtFinalDesvinculacao?: string;
        cdConcessionario?: number;
        limit?: number;
        page?: number;
        orderBy?: string;

    }) {
        this.tpConcessao = data && data.tpConcessao;
        this.cdConcessao = data && data.cdConcessao;
        this.cdPessoa = data && data.cdPessoa;
        this.nmPessoa = data && data.nmPessoa;
        this.cdConcessaoVeiculo = data && data.cdConcessaoVeiculo;
        this.cdVeiculo = data && data.cdVeiculo;
        this.nrPlaca = data && data.nrPlaca;
        this.nrPrefixo = data && data.nrPrefixo;
        this.nrIdentificador = data && data.nrIdentificador;
        this.nrAnoFabricacao = data && data.nrAnoFabricacao;
        this.nmModelo = data && data.nmModelo;
        this.dtInicioOperacao = data && data.dtInicioOperacao;
        this.stConcessaoVeiculo = data && data.stConcessaoVeiculo;
        this.stConcessao = data && data.stConcessao;
        this.dtInicialVinculacao = data && data.dtInicialVinculacao;
        this.dtFinalVinculacao = data && data.dtFinalVinculacao;
        this.dtInicialDesvinculacao = data && data.dtInicialDesvinculacao;
        this.dtFinalDesvinculacao = data && data.dtFinalDesvinculacao;
        this.nmUsuario = data && data.nmUsuario;
        this.cdConcessionario = data && data.cdConcessionario;
        this.limit = data && data.limit;
        this.page = data && data.page;
        this.orderBy = data && data.orderBy;
    }

    getFilters(): IFilter {
        let filtros: IFilter = new HttpFilter([
        ]);

        if (this.tpConcessao != null) {
            filtros.addFilter(new Equal('tpConcessao', this.tpConcessao));
        }
        
        if (this.cdConcessao != null) {
            filtros.addFilter(new Equal('cdConcessao', this.cdConcessao));
        }
        
        if (this.cdPessoa != null) {
            filtros.addFilter(new Equal('cdPessoa', this.cdPessoa));
        }
        
        if (this.nmPessoa) {
            filtros.addFilter(new Equal('nmPessoa', this.nmPessoa));
        }

        if (this.cdVeiculo != null) {
            filtros.addFilter(new Equal('cdVeiculo', this.cdVeiculo));
        }

        if (this.nrPrefixo ) {
            filtros.addFilter(new Equal('nrPrefixo', this.nrPrefixo));
        }

        if (this.nrPlaca ) {
            filtros.addFilter(new Equal('nrPlaca', this.nrPlaca));
        }

        if (this.nrIdentificador) {
            filtros.addFilter(new Equal('nrIdentificador', this.nrIdentificador));
        }

        if (this.nrAnoFabricacao && this.nrAnoFabricacao != null) {
            filtros.addFilter(new Equal('nrAnoFabricacao', this.nrAnoFabricacao));
        }

        if (this.nmModelo && this.nmModelo != null) {
            filtros.addFilter(new Equal('nmModelo', this.nmModelo));
        }

        if (this.dtInicioOperacao) {
            filtros.addFilter(new Equal('dtInicioOperacao', formatDate(this.dtInicioOperacao, 'yyyy-MM-dd', 'en-US')));
        }
        
        if (this.cdConcessaoVeiculo != null) {
            filtros.addFilter(new Equal('cdConcessaoVeiculo', this.cdConcessaoVeiculo));
        }
            
        if (this.stConcessaoVeiculo != null) {
            filtros.addFilter(new Equal('stConcessaoVeiculo', this.stConcessaoVeiculo));
        }

        if (this.nmUsuario != null) {
            filtros.addFilter(new Equal('nmUsuario', this.nmUsuario));
        }
        
        if(!isNaN(this.stConcessao) && this.stConcessao!=null){
            filtros.addFilter(new Equal('stConcessao', this.stConcessao));
        } 

        if (this.dtInicialVinculacao) {
            filtros.addFilter(new Equal('dtInicialVinculacao', formatDate(this.dtInicialVinculacao, 'yyyy-MM-dd', 'en-US')));
        }

        if (this.dtFinalVinculacao) {
            filtros.addFilter(new Equal('dtFinalVinculacao', formatDate(this.dtFinalVinculacao, 'yyyy-MM-dd', 'en-US')));
        }

        if (this.dtInicialDesvinculacao) {
            filtros.addFilter(new Equal('dtInicialDesvinculacao', formatDate(this.dtInicialDesvinculacao, 'yyyy-MM-dd', 'en-US')));
        }

        if (this.dtFinalDesvinculacao) {
            filtros.addFilter(new Equal('dtFinalDesvinculacao', formatDate(this.dtFinalDesvinculacao, 'yyyy-MM-dd', 'en-US')));
        }

        if (this.cdConcessionario){
            filtros.addFilter(new Equal('cdConcessionario', this.cdConcessionario));
        }

        if(this.limit){
            filtros.addFilter(new Equal('limit', this.limit));
        }  
        
        if(this.page){
            filtros.addFilter(new Equal('page', this.page));
        } 

        if(this.orderBy) {
            filtros.addFilter(new Equal('orderBy', this.orderBy));
        }

        return filtros;
    }
}
